export enum rangeBtn {
  'Lease End' = 'End Date',
  'Rent Review Date' = 'Review Date',
  'Lease Break Date' = 'Break Date',
  'End Date' = 'End Date',
}
export const rangeTypesList = ['range', 'range-buttons'];
